module.exports = __webpack_public_path__ + "img/Johto4Preview.201dc333.png";